import { actionTypes } from '../actions/actionTypes/payRollActionType';

let initialState = {
  OrgList: [],
  getPayrollLoader: false,
  changeOrg: false,
  payRollLoader: false,
  payRollData: {},
  formW4Data: [],
  formStateW4Data: [],
  getW4ConfigDetailsLoader: false,
  SubmitW4ConfigDetailsLoader: false,
  CaseInfo: [],
  ResolvedCaseInfo: [],
  ErrorCases: [],
  PendingCasesCount: 0,
  ErrorCasesCount: 0,
  OpenCasesCount: 0,
  OpenCases: [],
  ResolvedCaseInfoCount: 0,
  compensationDetails: [],
  Is2020W4Form: false,
  DisableGenerateFederalPDF: false,
  DisableGenerateStatePDF: false,
  getPayStubsDataLoader: false,
  PayPeriodDates: [],
  EmpId: '',
  payPeriodYears: [],
  downloadPayStubLoader: false,
  IsA2020W4Form: '',
  EmployeeDetails: [],
  Deduct401kfromBonus: '',
  ActiveEmployees: '',
  processOffcycleLoader: false,
  OffCycleCurrency: '',
  emailW4DataLoader: false,
  FederalDocBase64Code: '',
  FederalDocBefore2020Base64: '',
  StateDocBase64Code: '',
  w4Info: {},
  taxDocsDetails: {},
  getTaxDocsDetailsLoader: false,
  sendTaxDocMailLoader: false,
  SelectedLocation: '',
  Region: '',
  PayrollGetCallData: {},
  employeeList: [],
  searchEmpLoader: false,
  PayrollPayPeriodDates: [],
  PayrollPayPeriodDatesLoader: false,
  EmployeePayDate: '',
  ACHSelectionLoader: false,
  getYearsForPaystubsLoader: false,
  PayPeriods: [],
  OrgListPaystubs: [],
  sendMailForYearsPaystubsLoader: false,
  TaxIsPEOURL: false,
  PEOOrgList: [],
  IsPEOURLPaystubs: false,
  IsPEOURL: false,
  NeedsWhiteLabeling: false,
};
/**
 * Redux reducers.
 * Used to update state in the store after actions are issued.
 */
export function payRoll(state = initialState, action) {
  switch (action.type) {
    case actionTypes.POST_PAYROLL_SUCCESS:
      return {
        ...state,
        payRollData: action.cases.ErrorDescription ? state.payRollData : action.cases,
        OffCycleCurrency: action.cases?.CurrencyCode || '',
        EmployeeDetails: action?.cases?.TotalEmployeeList || [],
        payRollLoader: false,
        getProcessPayRollLoader: false,
      };

    case actionTypes.GET_OPEN_CASE_DETAILS_SUCCESS:
      return {
        ...state,
        payRollData: action.cases,
        EmployeeDetails: action?.cases?.TotalEmployeeList || [],
        Deduct401kfromBonus:
          action.cases?.data?.Deduct401kfromBonus === 'true' ||
          action.cases?.Deduct401kfromBonus === 'true'
            ? true
            : false,
        ActiveEmployees: action.cases?.ActiveEmployees,
        SelectedLocation: action?.cases?.LocationCode || '',
        Region: action?.cases?.Region || '',
        getPayrollLoader: false,
        getProcessPayRollLoader: false,
      };

    case actionTypes.GET_OPEN_CASE_DETAILS_FAILURE:
      return {
        ...state,
        payRollData: {},
        getPayrollLoader: false,
      };

    case actionTypes.POST_PAYROLL_FAILURE:
      return {
        ...state,
        payRollData: {},
        payRollLoader: false,
      };

    case actionTypes.RESET_PAYROLL_DATA:
      return {
        ...state,
        payRollData: {},
        EmployeeDetails: [],
        employeeList: [],
        PayrollPayPeriodDates: [],
        EmployeePayDate: '',
      };

    case actionTypes.SHOW_PAYROLL_LOADER:
      return {
        ...state,
        payRollLoader: true,
      };
    case actionTypes.GET_PAYROLL_SUCCESS:
      return {
        ...state,
        OrgList: action.cases.OrgList,
        CaseInfo: action.cases?.CaseInfo || [],
        ErrorCases: action.cases?.ErrorCases || [],
        PendingCasesCount: action.cases?.PendingCasesCount || 0,
        ErrorCasesCount: action.cases?.ErrorCasesCount || 0,
        OpenCasesCount: action.cases?.OpenCasesCount || 0,
        OpenCases: action.cases?.OpenCases || [],
        ResolvedCasesCount: action.cases?.ResolvedCasesCount || 0,
        ResolvedCaseInfo: action.cases?.ResolvedCaseInfo || [],
        getPayrollLoader: false,
        payRollLoader: false,
        PayrollGetCallData: action.cases || {},
        IsPEOURL: action?.cases?.IsPEOURL === 'true' || false,
        NeedsWhiteLabeling: action?.cases?.NeedsWhiteLabeling === 'true' || false,
      };

    case actionTypes.GET_PAYROLL_FAILURE:
      return {
        ...state,
        OrgList: [],
        getPayrollLoader: false,
        payRollLoader: false,
      };

    case actionTypes.SHOW_PAYROLL_LOADER_GET:
      return {
        ...state,
        getPayrollLoader: true,
      };

    case actionTypes.CHANGE_ORG:
      return {
        ...state,
        changeOrg: action.flag,
      };

    case actionTypes.GET_W4_CONFIG_DETAILS_SUCCESS:
      return {
        ...state,
        formW4Data: action.cases.FormW4Data || [],
        formStateW4Data: action.cases.FormStateW4Data || [],
        compensationDetails: action.cases.CompensationDetails || [],
        getW4ConfigDetailsLoader: false,
        Is2020W4Form: action.cases.Is2020W4Form === 'true' ? true : false || false,
        DisableGenerateFederalPDF:
          action.cases.DisableGenerateFederalPDF === 'true' ? true : false || false,
        DisableGenerateStatePDF:
          action.cases.DisableGenerateStatePDF === 'true' ? true : false || false,

        FederalDocBase64Code: action.cases.FederalDocBase64Code || '',
        FederalDocBefore2020Base64: action.cases.FederalDocBefore2020Base64 || '',
        StateDocBase64Code: action.cases.StateDocBase64Code || '',

        EmpId: action.cases.EmpID || '',
        payPeriodYears: action.cases?.PayPeriods || [],
        PayPeriodDates: [],
        IsA2020W4Form: action.cases.IsA2020W4Form,
        w4Info: action?.cases || {},
      };
    case actionTypes.GET_W4_CONFIG_DETAILS_FAILURE:
      return {
        ...state,
        formW4Data: [],
        formStateW4Data: [],
        compensationDetails: [],
        getW4ConfigDetailsLoader: false,
        Is2020W4Form: false,
        payPeriodYears: [],
        IsA2020W4Form: '',
      };
    case actionTypes.GET_W4_CONFIG_DETAILS_LOADER:
      return {
        ...state,
        getW4ConfigDetailsLoader: true,
      };

    case actionTypes.POST_W4_CONFIG_DETAILS_SUCCESS:
      return {
        ...state,
        formW4Data: action.cases.FormW4Data || [],
        formStateW4Data: action.cases.FormStateW4Data || [],
        DisableGenerateFederalPDF:
          action.cases.DisableGenerateFederalPDF === 'true' ? true : false || false,
        DisableGenerateStatePDF:
          action.cases.DisableGenerateStatePDF === 'true' ? true : false || false,
        SubmitW4ConfigDetailsLoader: false,
      };
    case actionTypes.POST_W4_CONFIG_DETAILS_FAILURE:
      return {
        ...state,
        formW4Data: [],
        formStateW4Data: [],
        SubmitW4ConfigDetailsLoader: false,
        Is2020W4Form: false,
        IsA2020W4Form: '',
      };
    case actionTypes.POST_W4_CONFIG_DETAILS_LOADER:
      return {
        ...state,
        SubmitW4ConfigDetailsLoader: true,
      };

    case actionTypes.GET_CALCULATE_TAX_DTLS_SUCCESS:
      return {
        ...state,
        payRollData:
          action.params.actionType === 'Withdraw'
            ? action.cases
            : action.cases.pyErrorMessage
            ? state.payRollData
            : action.cases,
        getCalculateTaxLoader: false,
        getProcessPayRollLoader: false,
      };
    case actionTypes.GET_CALCULATE_TAX_DTLS_FAILURE:
      return {
        ...state,
        payRollData: action.cases,
        getCalculateTaxLoader: false,
      };

    case actionTypes.GET_CALCULATE_TAX_DTLS_LOADER:
      return {
        ...state,
        getCalculateTaxLoader: true,
      };

    case actionTypes.POST_PROCESS_PAYROLL_SUCCESS:
      return {
        ...state,
        payRollData: action.cases,
        getProcessPayRollLoader: false,
      };
    case actionTypes.POST_PROCESS_PAYROLL_FAILURE:
      return {
        ...state,
        payRollData: action.cases,
        getProcessPayRollLoader: false,
      };

    case actionTypes.POST_PROCESS_PAYROLL_LOADER:
      return {
        ...state,
        getProcessPayRollLoader: true,
      };

    case actionTypes.GET_PAY_STUBS_DATA_SUCCESS:
      return {
        ...state,
        PayPeriodDates: action.cases.PayPeriodDates || [],
        getPayStubsDataLoader: false,
      };

    case actionTypes.GET_PAY_STUBS_DATA_FAILURE:
      return {
        ...state,
        PayPeriodDates: [],
        getPayStubsDataLoader: false,
      };

    case actionTypes.GET_PAY_STUBS_DATA_LOADER:
      return {
        ...state,
        getPayStubsDataLoader: true,
      };

    case actionTypes.DOWNLOAD_PAY_STUBS_DATA_SUCCESS:
      return {
        ...state,
        downloadPayStubLoader: false,
      };

    case actionTypes.DOWNLOAD_PAY_STUBS_DATA_FAILURE:
      return {
        ...state,
        downloadPayStubLoader: false,
      };

    case actionTypes.DOWNLOAD_PAY_STUBS_DATA_LOADER:
      return {
        ...state,
        downloadPayStubLoader: true,
      };

    case actionTypes.GET_EMP_OFFCYCLE_SUCCESS:
      return {
        ...state,
        getEmpDetailsOffcycleLoader: false,
        EmployeeDetails: action.cases?.data?.MonthlyPayrollDetails || [],
        Deduct401kfromBonus:
          action.cases?.data?.Deduct401kfromBonus === 'true' ||
          action.cases?.Deduct401kfromBonus === 'true'
            ? true
            : false,
        ActiveEmployees: action.cases?.data?.ActiveEmployees,
        OffCycleCurrency: action?.cases?.CurrencyCode || '',
        SelectedLocation: action?.cases?.data?.LocationCode || '',
        Region: action?.cases?.data?.Region || '',
      };

    case actionTypes.GET_EMP_OFFCYCLE_FAILURE:
      return {
        ...state,
        getEmpDetailsOffcycleLoader: false,
        EmployeeDetails: [],
      };

    case actionTypes.GET_EMP_OFFCYCLE_LOADER:
      return {
        ...state,
        getEmpDetailsOffcycleLoader: true,
      };

    case actionTypes.PROCESS_OFFCYCLE_SUCCESS:
      return {
        ...state,
        payRollData: action.cases,
        processOffcycleLoader: false,
      };
    case actionTypes.PROCESS_OFFCYCLE_FAILURE:
      return {
        ...state,
        payRollData: action.cases,
        processOffcycleLoader: false,
      };

    case actionTypes.PROCESS_OFFCYCLE_LOADER:
      return {
        ...state,
        processOffcycleLoader: true,
      };
    case actionTypes.EMAIL_W4_DATA_LOADER:
      return {
        ...state,
        emailW4DataLoader: true,
      };
    case actionTypes.EMAIL_W4_DATA_FAILURE:
      return {
        ...state,
        emailW4DataLoader: false,
      };
    case actionTypes.EMAIL_W4_DATA_SUCCESS:
      return {
        ...state,
        emailW4DataLoader: false,
      };

    case actionTypes.GET_TAX_DOC_DETAILS_SUCCESS:
      return {
        ...state,
        getTaxDocsDetailsLoader: false,
        taxDocsDetails: action?.cases || {},
        TaxIsPEOURL: action?.cases?.IsPEOURL === 'true' || false,
        PEOOrgList: action?.cases?.OrgList || [],
      };
    case actionTypes.GET_TAX_DOC_DETAILS_FAILURE:
      return {
        ...state,
        getTaxDocsDetailsLoader: false,
        taxDocsDetails: {},
      };
    case actionTypes.GET_TAX_DOC_DETAILS_LOADER:
      return {
        ...state,
        getTaxDocsDetailsLoader: true,
      };

    case actionTypes.SEND_TAX_DOC_MAIL_SUCCESS:
      return {
        ...state,
        sendTaxDocMailLoader: false,
      };
    case actionTypes.SEND_TAX_DOC_MAIL_FAILURE:
      return {
        ...state,
        sendTaxDocMailLoader: false,
      };
    case actionTypes.SEND_TAX_DOC_MAIL_LOADER:
      return {
        ...state,
        sendTaxDocMailLoader: true,
      };

    case actionTypes.SEARCH_EMP_PAYROLL_PAYSTUB_SUCCESS:
      return {
        ...state,
        employeeList: action.cases.EmployeeList || [],
        searchEmpLoader: false,
      };
    case actionTypes.SEARCH_EMP_PAYROLL_PAYSTUB_FAILURE:
      return {
        ...state,
        searchEmpLoader: false,
      };
    case actionTypes.SEARCH_EMP_PAYROLL_PAYSTUB_LOADER:
      return {
        ...state,
        searchEmpLoader: true,
      };
    case actionTypes.GET_EMP_PAYROLL_PAYSTUB_DATA_SUCCESS:
      return {
        ...state,
        PayrollPayPeriodDates: action?.cases?.PayPeriodDates || [],
        PayrollPayPeriodDatesLoader: false,
      };
    case actionTypes.GET_EMP_PAYROLL_PAYSTUB_DATA_FAILURE:
      return {
        ...state,
        PayrollPayPeriodDatesLoader: false,
      };
    case actionTypes.GET_EMP_PAYROLL_PAYSTUB_DATA_LOADER:
      return {
        ...state,
        PayrollPayPeriodDatesLoader: true,
      };

    case actionTypes.ACH_SELECTION_SUCCESS:
      return {
        ...state,
        EmployeePayDate: action?.cases?.PayDate || '',
        ACHSelectionLoader: false,
      };
    case actionTypes.ACH_SELECTION_FAILURE:
      return {
        ...state,
        ACHSelectionLoader: false,
      };
    case actionTypes.ACH_SELECTION_LOADER:
      return {
        ...state,
        ACHSelectionLoader: true,
      };

    case actionTypes.GET_YEARS_FOR_PAYSTUBS_SUCCESS:
      return {
        ...state,
        OrgListPaystubs: action.cases?.OrgList || [],
        getYearsForPaystubsLoader: false,
        IsPEOURLPaystubs: action?.cases?.IsPEOURL === 'true' || false,
      };
    case actionTypes.GET_YEARS_FOR_PAYSTUBS_FAILURE:
      return {
        ...state,
        getYearsForPaystubsLoader: false,
      };
    case actionTypes.GET_YEARS_FOR_PAYSTUBS_LOADER:
      return {
        ...state,
        getYearsForPaystubsLoader: true,
      };

    case actionTypes.SEND_MAIL_FOR_YEARS_PAYSTUBS_SUCCESS:
      return {
        ...state,
        sendMailForYearsPaystubsLoader: false,
      };
    case actionTypes.SEND_MAIL_FOR_YEARS_PAYSTUBS_FAILURE:
      return {
        ...state,
        sendMailForYearsPaystubsLoader: false,
      };
    case actionTypes.SEND_MAIL_FOR_YEARS_PAYSTUBS_LOADER:
      return {
        ...state,
        sendMailForYearsPaystubsLoader: true,
      };

    default:
      return state;
  }
}
